import { makeStyles } from '@material-ui/core';
import { green, purple, red, yellow } from 'globals/colors';

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    '& > div': {
      flexWrap: 'nowrap',
    },
    '& [role=alert]': {
      backgroundColor: `${purple.BRAND}`,
      fontSize: 14,
    },
    '& svg': {
      marginRight: spacing(1),
    },
  },
  variantSuccess: { backgroundColor: `${green.MAIN} !important` },
  variantError: { backgroundColor: `${red.MAIN} !important` },
  variantWarning: { backgroundColor: `${yellow.MAIN} !important` },
  variantInfo: { backgroundColor: `${purple.BRAND} !important` },
}));
